<ng-template #factRow let-fact>
  <td class="col-hero col-center">
    <app-daily-fact-hero [hero]="fact.hero" />
  </td>
  <td class="date-cell col-center">{{ fact.date }}</td>
  <td class="col-center">
    <span class="category-badge">{{ fact.category || '-' }}</span>
  </td>
  <td class="fact-cell">{{ fact.fact }}</td>
  <td class="col-center">
    <app-daily-fact-status-badge
      [status]="fact.videoStatus"
      [label]="getVideoStatusLabel()(fact.videoStatus)"
      [statusClass]="getVideoStatusClass()(fact.videoStatus)"
    />
  </td>
  <td class="col-center col-actions">
    <app-daily-fact-actions
      [fact]="fact"
      [isGenerating]="isGenerating()(fact.id)"
      [canReview]="canReviewVideo()(fact)"
      (generate)="generateVideo.emit($event)"
      (review)="reviewVideo.emit($event)"
    />
  </td>
</ng-template>

<app-admin-data-table
  [columns]="columns"
  [rows]="facts()"
  [rowTemplate]="factRow"
  [trackByProp]="trackFact"
  variant="desktop-only"
/>
